//angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const SettingsRoutes: Routes = [
  {
    loadChildren: () => import('./advanced-settings/advanced-settings.module').then(m => m.AdvancedSettingsModule),
    path: 'advanced',
    pathMatch: 'prefix'
  },
  {
    loadChildren: () => import('./store-setup/store.module').then(m => m.StoreModule),
    path: 'store',
    pathMatch: 'prefix'
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'store',
  }
];

@NgModule({
    exports: [ RouterModule ],
    imports: [ RouterModule.forChild(SettingsRoutes) ]
})

export class SettingsRoutingModule {
    constructor() {
        console.log(`@settings.routing.ts was loaded.`)
    }
}
